import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import FleetWebApi from "../Api/FleetWebApi";
import alertLabsApi from "../Api/AlertLabsApi";
import { useAuthDataContext } from "../AuthDataProvider";

const DeviceLookup = () => {
  const navigate = useNavigate();
  const { user } = useAuthDataContext();
  const [value, setValue] = useState("");
  const [redirect, setRedirect] = useState(null);
  
  async function getCoreID(lookupId) {
    lookupId = lookupId.split(".").join("");
    let coreIdToSearch = lookupId;
    
    // If input is 24 chars (could be core ID or virtual ID), try virtual ID conversion
    if (lookupId.length === 24) {
      try {
        const hardwareIDs = await alertLabsApi.getHardwareIDFromSensorID(
          lookupId,
          'particle',
          user.token
        );
        
        if (hardwareIDs && hardwareIDs.length > 0 && hardwareIDs[0]) {
          // Successfully converted virtual ID to particle core ID
          coreIdToSearch = hardwareIDs[0];
        }
      } catch (error) {
        // API failed, input must already be a core ID
      }
      
      setRedirect("/device/" + coreIdToSearch);
      return null;
    }
    
    if (lookupId.length === 18) {
      setRedirect("/device/" + lookupId);
      return null;
    }
    
    // For other lengths assume serial numbers and look up core ID
    FleetWebApi.getDeviceCoreID(lookupId).then(
      (result) => {
        setRedirect("/device/" + result);
        return null;
      },
      (error) => {
        console.log(error);
        setRedirect("/device/" + lookupId);
        return null;
      }
    );
  }
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    getCoreID(value);
  };

  useEffect(() => {
    if (redirect !== null) {
      navigate(redirect);
    }
  }, [redirect, navigate]);

  return (
    <Paper>
      <form onSubmit={handleSubmit} style={{ justifyContent: "center" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            id="outlined-name"
            label="Serial / Virtual / Core"
            value={value}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
            style={{ marginLeft: 5, marginRight: 5 }}
          />
          <Button
            variant="contained"
            type="submit"
            color="secondary"
            label="Submit"
            style={{ marginLeft: 5, marginRight: 5 }}
          >
            Submit
          </Button>
        </div>
      </form>
    </Paper>
  );
};

export default DeviceLookup;
